import React, { useState } from 'react';
import { auth } from '../firebase';

const Contact: React.FC = () => {
  const [email, setEmail] = useState(auth.currentUser?.email || '');
  const [sujet, setSujet] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!sujet.trim() || !message.trim()) return;
    setSending(true);
    setError('');
    try {
      const res = await fetch('https://aglomera.com/api/contact/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, sujet, message }),
      });
      if (res.ok) {
        setSent(true);
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.error || 'Une erreur est survenue, veuillez réessayer.');
      }
    } catch {
      setError('Impossible d\'envoyer le message. Vérifiez votre connexion.');
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="p-8 flex flex-col items-center justify-center h-96 text-center gap-4">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-2" style={{ background: '#dcfce7' }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-gray-900">Message envoyé !</h2>
        <p className="text-sm text-gray-500 max-w-xs">
          Nous avons bien reçu votre message et vous répondrons dans les meilleurs délais.
        </p>
        <button
          onClick={() => { setSent(false); setSujet(''); setMessage(''); }}
          className="mt-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white hover:opacity-90 transition-all"
          style={{ background: '#2a52a8' }}
        >
          Envoyer un autre message
        </button>
      </div>
    );
  }

  return (
    <div className="p-8 w-full max-w-lg mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Nous contacter</h1>
        <p className="text-sm text-gray-500 mt-1">
          Une question, un problème ou une suggestion ? On vous répond rapidement.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <div>
          <label className="text-xs font-semibold text-gray-500 block mb-1.5">Votre email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="email@exemple.com"
            required
            className="w-full text-sm px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-400 transition-colors"
          />
        </div>

        <div>
          <label className="text-xs font-semibold text-gray-500 block mb-1.5">Sujet</label>
          <input
            type="text"
            value={sujet}
            onChange={e => setSujet(e.target.value)}
            placeholder="Problème technique, question..."
            required
            maxLength={200}
            className="w-full text-sm px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-400 transition-colors"
          />
        </div>

        <div>
          <label className="text-xs font-semibold text-gray-500 block mb-1.5">Message</label>
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Décrivez votre demande..."
            required
            rows={6}
            maxLength={2000}
            className="w-full text-sm px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:border-blue-400 transition-colors resize-none"
          />
          <p className="text-right text-xs text-gray-400 mt-1">{message.length}/2000</p>
        </div>

        {error && (
          <div className="text-sm text-red-600 bg-red-50 border border-red-100 px-4 py-3 rounded-xl">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={sending || !sujet.trim() || !message.trim()}
          className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all disabled:opacity-50 hover:opacity-90"
          style={{ background: '#2a52a8' }}
        >
          {sending ? 'Envoi en cours...' : 'Envoyer le message'}
        </button>

        <p className="text-xs text-center text-gray-400">
          Votre message sera envoyé à notre équipe.<br />Temps de réponse habituel : sous 24h.
        </p>
      </form>
    </div>
  );
};

export default Contact;
